import React, { useEffect, useRef, useState } from "react";
import { DataGrid } from "@mui/x-data-grid"; // Material-UI DataGrid
import { CommonAPImain } from "../../../Utils/API/CommonAPImain/CommonAPImain";
import "./TopReports.scss";

const Customer = () => {
  const [saleReportData, setSaleReportData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const gridRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (gridRef.current) {
        gridRef.current.style.height = `${window.innerHeight - 130}px`;
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setIsLoading(true);
    CommonAPImain("Performance_Customer")
      .then((response) => {
        if (response?.Status == 200) {
          const saleData = response?.Data?.DT.map((item, index) => ({
            ...item,
            id: item.SrNo || index,
          }));
          setSaleReportData(saleData);
          setIsLoading(false);
        }
      })
      .catch((err) => console.log(err));
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "CustomerCode", headerName: "Customer", width: 150 },
    { field: "GrossWt", headerName: "GWT", width: 120 },
    { field: "NetWt", headerName: "NWT", width: 120 },
    { field: "JobCount", headerName: "Job Count", width: 100 },
    { field: "Amount", headerName: "Amount", width: 120 },
    // { field: "SaleGrossWt", headerName: "Sale Gross Wt", width: 150 },
    // {
    //   field: "SaleReturnGrossWt",
    //   headerName: "Sale Return Gross Wt",
    //   width: 170,
    // },
    // { field: "SaleNetWt", headerName: "Sale Net Wt", width: 120 },
    // { field: "SaleReturnNetWt", headerName: "Sale Return Net Wt", width: 170 },
    // { field: "SaleAmount", headerName: "Sale Amount", width: 150 },
    // { field: "SaleRetunAmount", headerName: "Sale Return Amount", width: 170 },
    // { field: "SaleJobCount", headerName: "Sale Job Count", width: 150 },
    // {
    //   field: "SaleRetunJobCount",
    //   headerName: "Sale Return Job Count",
    //   width: 180,
    // },
  ];

  return (
    <div>
      <div
        ref={gridRef}
        style={{
          width: "100%",
          backgroundColor: "white",
        }}
      >
        <DataGrid
          rows={saleReportData}
          columns={columns}
          className="topReport_dataGrid_customer"
          localeText={{ noRowsLabel: "No Data" }}
          pagination={false}
          loading={isLoading}
          components={{
            Toolbar: () => null,
            LoadingOverlay: () => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                Loading...
              </div>
            ),
          }}
        />
      </div>
    </div>
  );
};

export default Customer;
